import {
  isPending,
  isFulfilled,
  isRejected,
  type Middleware,
} from '@reduxjs/toolkit';

import { TrackableAction } from '@/types/changePassword';

import { apiPending, apiSettled } from '../apiTracker/apiTrackerSlice';
import type { AppDispatch, RootState } from '../store';

const BODY_LOADER_DELAY = 2000;
const requestTimeouts: Record<string, ReturnType<typeof setTimeout>> = {};
const loadingMiddleware: Middleware<object, RootState, AppDispatch> =
  store => next => (action: any) => {
    if (action?.type?.startsWith('host')) {
      // Type guard to check if it's a Redux action
      if (typeof action !== 'object' || action === null) {
        return next(action);
      }
      const trackableAction = action as TrackableAction;
      const requestId = trackableAction.meta?.requestId;
      const isTracked = () => {
        if (trackableAction.meta?.arg?.type === 'query') {
          const payloadAction = trackableAction.meta.arg.originalArgs?.action;
          if (payloadAction && payloadAction !== 'start') {
            return false;
          }
          return true;
        }
        if (trackableAction.meta?.arg?.type === 'mutation') {
          return true;
        }
        return false;
      };
      if (isTracked() && requestId) {
        if (isPending(action)) {
          const timeout = setTimeout(() => {
            store.dispatch(apiPending(requestId));
            delete requestTimeouts[requestId];
          }, BODY_LOADER_DELAY);
          requestTimeouts[requestId] = timeout;
        } else if (isFulfilled(action) || isRejected(action)) {
          if (requestTimeouts[requestId]) {
            clearTimeout(requestTimeouts[requestId]);
            delete requestTimeouts[requestId];
          }
          store.dispatch(apiSettled(requestId));
        }
      }
    }
    return next(action);
  };
export default loadingMiddleware;
